<template>
  <div id="paths-container">
    <PathButton
      v-for="path in paths"
      v-on="{ handleSelectPath }"
      :path="path"
      :activePath="activePath"
      :key="path"
    />
  </div>
</template>

<script>
import CONSTANTS from "@/constants.js";
import PathButton from "@/components/Projects/Showrooms/Homepage/PathButton";
import { mapActions } from "vuex";

export default {
  name: "ShowroomPaths",
  computed: {
    paths() {
      return CONSTANTS.SHOWROOM_INSTITUTION_NAMES;
    },
  },

  methods: {
    ...mapActions("showroom", [
      "setPath",
      "setSelectedCatalogs",
      "updateShowroomColor",
    ]),
    handleSelectPath(payload) {
      this.setPath(payload.path);
      this.setSelectedCatalogs([]);

      //reset c2 and c3 if not school or team
      if (payload.path !== "school") {
        this.updateShowroomColor({ colorId: null, colorKey: "color_2" });
        this.updateShowroomColor({ colorId: null, colorKey: "color_3" });

        if (payload.path === "team") {
          this.updateShowroomColor({ colorId: null, colorKey: "color_1" });
        }
      }
      this.$emit("handleSelectPath", payload);
    },
  },

  props: {
    activePath: {
      type: String,
      required: true,
    },
  },

  components: {
    PathButton,
  },
};
</script>

<style lang="scss" scoped>
#paths-container {
  display: flex;
  margin-bottom: 1em;
}
</style>